import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { EARNING } from "helpers/viewContent";
import { getDetail_ } from "store/services/commonService";
import { DATE_FORMAT_TIME } from "helpers/common";

//imported
import * as Path from "routes/paths";
import * as actions from "store/actions/index.js";

const Detail = ({ dispatch, match }) => {
  let editkey = match.params.id;
  const [editData, setEditData] = useState({});
  async function getData() {
    try {
      let query = {
        url: "earning/view",
        id: editkey,
      };
      dispatch(actions.persist_store({ loader: true }));
      let res = await dispatch(getDetail_(query));
      setEditData(res?.body);
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      dispatch(actions.persist_store({ loader: false }));
      console.log(err);
    }
  }

  useEffect(() => {
    if (editkey) {
      getData();
    }
  }, []);

  return (
    <>
      <Helmet title={EARNING.CURRENT_MODULE} />
      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-wallet menu-icon"></i>
          </span>{" "}
          {EARNING.CURRENT_VIEW}
        </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={Path.earning}>{EARNING.CURRENT_MODULE}</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Detail
            </li>
          </ol>
        </nav>
      </div>

      <div className="row">
        <div className="col-md-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <p className="card-description"> Earning info </p>
              <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-6 col-form-label">Earning Date</label>
                      <div className="col-sm-6 col-form-label">
                        {editData?.date ? DATE_FORMAT_TIME(editData?.date) : "N/A"}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-6 col-form-label">Earning</label>
                      <div className="col-sm-6 col-form-label">
                        {editData.total_amount ? `$ ${editData.total_amount}` : 'N/A'}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-6 col-form-label">Payment Status</label>
                      <div className="col-sm-6 col-form-label">
                        {editData?.payment_status ? editData?.payment_status : "N/A"}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-6 col-form-label">Payment Method</label>
                      <div className="col-sm-6 col-form-label">
                      {`${editData?.payment_method === 0 ? 'Card' : editData.payment_method === 1 ? 'Wallet' : 'Cash'}`}
                      </div>
                    </div>
                  </div>
              </div>
              <hr />
              <p className="card-description"> Earning From info </p>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">First Name</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.user?.name ? editData?.user?.name : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Last Name</label>
                    <div className="col-sm-6 col-form-label">
                    {editData?.user?.last_name ? editData?.user?.last_name : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Email</label>
                    <div className="col-sm-6 col-form-label">
                    {editData?.user?.email ? editData?.user?.email : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Phone Number</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.user?.phone ? `${editData?.user?.country_code}${editData?.user?.phone}` : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-6 col-form-label">Image</label>
                  <div className="col-sm-6 col-form-label">
                    <a
                      href={editData?.user?.image ? `${editData?.user?.image}` : "#"}
                      target="_blank"
                    >
                      <img
                        src={`${editData?.user?.image}`}
                        className="mb-2 rounded img-view"
                        alt="image"
                      />
                    </a>
                  </div>
                </div>
              </div>
           
              <hr />
              <p className="card-description"> Match Infp : </p>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Match Title</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.match?.match_title ? editData?.match?.match_title : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Match Date</label>
                    <div className="col-sm-6 col-form-label">
                    {editData?.match?.match_date ? DATE_FORMAT_TIME(editData?.match?.match_date) : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Location</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.match?.location ? editData?.match?.location : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToPros = (state) => {
  return {};
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(Detail);
